import scheme from "refractor/scheme";
export default scheme;